import Vue from "vue";
const state = {
  status: '',
  token: localStorage.getItem('token') || '',
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  modal: false,
  showVerifyNotice: false
};

const mutations = {
  auth_request: function (state) {
    state.status = 'loading';
    //state.modal = false;
  },
  auth_success: function (state, payload) {
    state.status = 'success';
    state.token = payload.token;
    state.user = payload.user;
  },
  auth_error: function (state) {
    state.status = 'error';
    state.modal = true;
  },
  logout: function (state) {
    //state.modal = true;
    state.status = '';
    state.token = '';
  },
  hide_modal: function (state) {
    state.modal = false;
    ga('send', 'event', 'Login/Register', 'Hide modal');
  },
  show_modal: function (state) {
    ga('send', 'event', 'Login/Register', 'Show modal');
    state.modal = true;
  },
  hide_verify_notice: function (state) {
    state.showVerifyNotice = false;
  },
  show_verify_notice: function (state) {
    state.showVerifyNotice = true;
  },
  load_user: function (state, user) {
    state.user = user;
  },
  set_user_verified: function (state, verifiedAt) {
    Vue.set(state.user, 'phone_verified_at', verifiedAt);
    localStorage.setItem('user', JSON.stringify(state.user));
  },
  update_user_email: function (state, email) {
    Vue.set(state.user, 'email', email);
    localStorage.setItem('user', JSON.stringify(state.user));
  },
  update_user_phone: function (state, phone) {
    Vue.set(state.user, 'phone', phone);
    localStorage.setItem('user', JSON.stringify(state.user));
  }
};

const actions = {
  login: function (context, user) {
    return new Promise((resolve, reject) => {
      context.commit('auth_request');
      axios
        .post('/api/login-with-phone', user)
        .then(response => {
          ga('send', 'event', 'Login/Register', 'Login successfull');
          const token = response.data.token;
          const user = response.data.user;
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          context.commit('auth_success', {
            token,
            user,
          });
          this.dispatch('profile/loadSavedShiurim', response.data.savedShiurim);
          this.dispatch('profile/loadFollowingSpeakers', response.data.followingSpeakers);
          this.dispatch('profile/loadShiurimNewsletter', response.data.shiurimNewsletter);
          resolve(response);
        })
        .catch(error => {
          context.commit('auth_error', error);
          localStorage.removeItem('token');
          reject(error);
        });
    });
  },
  register: function (context, user) {
    return new Promise((resolve, reject) => {
      context.commit('auth_request');
      axios
        .post('/api/register-with-verification', user)
        .then(response => {
          ga('send', 'event', 'Login/Register', 'Registration successfull');
          const token = response.data.token;
          const user = response.data.user;
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
          context.commit('auth_success', {
            token,
            user,
          });
          this.dispatch('profile/loadSavedShiurim', response.data.savedShiurim);
          this.dispatch('profile/loadFollowingSpeakers', response.data.followingSpeakers);
          this.dispatch('profile/loadShiurimNewsletter', response.data.shiurimNewsletter);
          resolve(response);
        })
        .catch(error => {
          context.commit('auth_error', error);
          localStorage.removeItem('token');
          reject(error);
        });
    });
  },
  logout: function (context) {
    return new Promise((resolve, reject) => {
      axios.post('/api/logout').then(() => {
        context.commit('logout');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete axios.defaults.headers.common['Authorization'];
        resolve();
        window.location.reload()
      });
    });
  },
  setUserVerified(context, verifiedAt) {
    context.commit('set_user_verified', verifiedAt);
  },
  hideModal: function (context) {
    return context.commit('hide_modal');
  },
  showModal: function (context) {
    return context.commit('show_modal');
  },
  hideVerifyNotice: function (context) {
    return context.commit('hide_verify_notice');
  },
  showVerifyNotice: function (context) {
    return context.commit('show_verify_notice');
  },
  loadUser: function (context, user) {
    return context.commit('load_user', user);
  },
  updateUserEmail: function (context, email) {
    return context.commit('update_user_email', email);
  },
  updateUserPhone: function (context, phone) {
    return context.commit('update_user_phone', phone);
  }
};

const getters = {
  isLoggedIn: function (state) {
    return !!state.token;
  },
  authStatus: function (state) {
    return state.status;
  },
  user: function (state) {
    return state.user;
  },
  isUserVerified: function (state) {
    return state.user ? !!state.user.phone_verified_at : false;
  },
  showVerifyNotice: function (state) {
    return state.showVerifyNotice;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
